export default __webpack_public_path__ + "static/image0-f4d6e95953a72a825b7119b042dce80a.webp";